module.exports = __webpack_public_path__ + "static/media/sopt25ru.38a9328e.pdf";